<ng-container *ngIf="!result.show; else tmpResult">
  <div class="modal-body py-4">
    <h3 class="text-center my-2 fw-bold">Recupera tu contraseña</h3>
    <div class="row">
      <div class="text-center my-2">
        <p>
          Por favor ingresa el RUT del proveedor y correo electrónico registrado
          para recuperar tu contraseña
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 justify-content-center">
        <form
          class="row d-flex flex-column align-items-center"
          (ngSubmit)="submit()"
          [formGroup]="recoverForm"
        >
          <div class="col-8 p-0 my-2">
            <label for="user" class="form-label">RUT</label>
            <div class="input-group prefix">
              <input
                type="text"
                class="form-control"
                id="rut"
                placeholder="11.111.111-1"
                maxlength="12"
                formControlName="rut"
                value="{{ rutProveedor | rut }}"
              />
              <div *ngIf="invalidRut" class="invalid-message">
                Por favor ingrese un rut válido
              </div>
            </div>
          </div>
          <div class="col-8 d-flex flex-column p-0 my-2">
            <label for="password" class="form-label">Correo electrónico</label>
            <div class="input-group prefix">
              <input
                type="email"
                class="form-control"
                id="email"
                placeholder="john.nieves@gmail.com"
                formControlName="email"
              />
              <div *ngIf="invalidEmail" class="invalid-message">
                Por favor ingrese una email válido
              </div>
            </div>
          </div>
          <div class="col-4 d-flex justify-content-center my-4">
            <div>
              <re-captcha formControlName="recaptcha" required></re-captcha>
            </div>
          </div>
          <div class="col-8 d-flex flex-column p-0 my-4">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="this.recoverForm.invalid || loading"
            >
              <ng-container *ngIf="!loading; else btnSpinner">
                Recordar contraseña
              </ng-container>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #btnSpinner>
  <span
    class="spinner-border spinner-border-sm"
    role="status"
    aria-hidden="true"
  ></span>
  <span class="visually-hidden">Procesando...</span>
</ng-template>

<ng-template #tmpResult>
  <app-modal-exito
    [title]="result.title"
    [message]="result.message"
    btnText="Cerrar"
  ></app-modal-exito>
</ng-template>
